import React, { memo, useCallback } from 'react';

import { IconButton } from '@mui/material';
import PropTypes from 'prop-types';

const EmojiButton = memo(({ emoji = '', onSelect, dataTestId = null }) => {
  const onClick = useCallback(() => {
    onSelect(emoji);
  }, [emoji, onSelect]);

  return (
    <IconButton data-testid={dataTestId} size="small" onClick={onClick}>
      {emoji}
    </IconButton>
  );
});
EmojiButton.propTypes = {
  onSelect: PropTypes.func.isRequired,
  emoji: PropTypes.string,
  dataTestId: PropTypes.string,
};

export default EmojiButton;
